import type { LucideIcon } from "lucide-react";
import { COR_ICONE_TOM, FUNDO_TOM, type Tom } from "@/modules/escala/format";

interface PillProps {
  tom: Tom;
  icone?: LucideIcon;
  children: string;
  className?: string;
}

/**
 * Selo de estado do módulo Escala (resposta, "Cancelada", "Opcional"...).
 * O estado nunca depende só da cor: leva ícone e texto. Texto em `text-text`
 * (contraste AA sobre o fundo tingido nos dois temas); só o ícone usa a cor do
 * estado — ver `FUNDO_TOM`/`COR_ICONE_TOM` em `format.ts`.
 */
export function Pill({ tom, icone: Icone, children, className = "" }: PillProps) {
  return (
    <span
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-bold leading-snug text-text ${FUNDO_TOM[tom]} ${className}`}
    >
      {Icone && <Icone size={13} aria-hidden className={`shrink-0 ${COR_ICONE_TOM[tom]}`} />}
      {children}
    </span>
  );
}
